"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@umich-lib/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var rotation = (0, _core.keyframes)(_templateObject());
var Container = ( /*#__PURE__*/0, _styledBase["default"])('div', {
  target: "e1y863ul0",
  label: "Container"
})("width:10rem;height:10rem;", function (props) {
  if (props.small) {
    return {
      width: '2rem',
      height: '2rem',
      'circle': {
        strokeWidth: '12'
      }
    };
  }
}, {
  animation: "".concat(rotation, " .8s infinite linear")
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpQmtCIiwiZmlsZSI6Ii4uL3NyYy9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQge1xuICBDT0xPUlNcbn0gZnJvbSAnQHVtaWNoLWxpYi9zdHlsZXMnXG5cbmNvbnN0IHJvdGF0aW9uID0ga2V5ZnJhbWVzYFxuICBmcm9tIHtcbiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgwZGVnKTtcbiAgfVxuICB0byB7XG4gICAgdHJhbnNmb3JtOiByb3RhdGUoMzU5ZGVnKTtcbiAgfVxuYFxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQoJ2RpdicpKFxuICB7XG4gICAgd2lkdGg6ICcxMHJlbScsXG4gICAgaGVpZ2h0OiAnMTByZW0nLFxuICB9LFxuICBwcm9wcyA9PiB7XG4gICAgaWYgKHByb3BzLnNtYWxsKSB7XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogJzJyZW0nLFxuICAgICAgICBoZWlnaHQ6ICcycmVtJyxcbiAgICAgICAgJ2NpcmNsZSc6IHtcbiAgICAgICAgICBzdHJva2VXaWR0aDogJzEyJ1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9LFxuICB7XG4gICAgYW5pbWF0aW9uOiBgJHtyb3RhdGlvbn0gLjhzIGluZmluaXRlIGxpbmVhcmBcbiAgfVxuKVxuXG5jb25zdCBTVkcgPSBzdHlsZWQoJ3N2ZycpKHtcbiAgZmlsbDogJ3RyYW5zcGFyZW50J1xufSlcblxuY29uc3QgQ2lyY2xlID0gc3R5bGVkKCdjaXJjbGUnKSh7XG4gIHN0cm9rZTogQ09MT1JTLnRlYWxbJzQwMCddLFxuICBzdHJva2VEYXNoYXJyYXk6ICcyNDAnLFxuICBzdHJva2VXaWR0aDogJzgnLFxuICBzdHJva2VEYXNob2Zmc2V0OiAnNDAnXG59KVxuXG5mdW5jdGlvbiBMb2FkaW5nKHByb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciB7Li4ucHJvcHN9PlxuICAgICAgPFNWRyB2aWV3Qm94PVwiLTc1IC03NSAxNTAgMTUwXCI+XG4gICAgICAgIDx0aXRsZT5Mb2FkaW5nPC90aXRsZT5cbiAgICAgICAgPENpcmNsZSBjeD1cIjBcIiBjeT1cIjBcIiByPVwiMzcuNVwiIC8+XG4gICAgICA8L1NWRz5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKVxufVxuXG5Mb2FkaW5nLnByb3BUeXBlcyA9IHtcbiAgc21hbGw6IFByb3BUeXBlcy5ib29sXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMb2FkaW5nIl19 */");
var SVG = ( /*#__PURE__*/0, _styledBase["default"])('svg', {
  target: "e1y863ul1",
  label: "SVG"
})(process.env.NODE_ENV === "production" ? {
  name: "1ntfbxl",
  styles: "fill:transparent;"
} : {
  name: "1ntfbxl",
  styles: "fill:transparent;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQ1kiLCJmaWxlIjoiLi4vc3JjL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7XG4gIENPTE9SU1xufSBmcm9tICdAdW1pY2gtbGliL3N0eWxlcydcblxuY29uc3Qgcm90YXRpb24gPSBrZXlmcmFtZXNgXG4gIGZyb20ge1xuICAgIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpO1xuICB9XG4gIHRvIHtcbiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgzNTlkZWcpO1xuICB9XG5gXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZCgnZGl2JykoXG4gIHtcbiAgICB3aWR0aDogJzEwcmVtJyxcbiAgICBoZWlnaHQ6ICcxMHJlbScsXG4gIH0sXG4gIHByb3BzID0+IHtcbiAgICBpZiAocHJvcHMuc21hbGwpIHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiAnMnJlbScsXG4gICAgICAgIGhlaWdodDogJzJyZW0nLFxuICAgICAgICAnY2lyY2xlJzoge1xuICAgICAgICAgIHN0cm9rZVdpZHRoOiAnMTInXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH0sXG4gIHtcbiAgICBhbmltYXRpb246IGAke3JvdGF0aW9ufSAuOHMgaW5maW5pdGUgbGluZWFyYFxuICB9XG4pXG5cbmNvbnN0IFNWRyA9IHN0eWxlZCgnc3ZnJykoe1xuICBmaWxsOiAndHJhbnNwYXJlbnQnXG59KVxuXG5jb25zdCBDaXJjbGUgPSBzdHlsZWQoJ2NpcmNsZScpKHtcbiAgc3Ryb2tlOiBDT0xPUlMudGVhbFsnNDAwJ10sXG4gIHN0cm9rZURhc2hhcnJheTogJzI0MCcsXG4gIHN0cm9rZVdpZHRoOiAnOCcsXG4gIHN0cm9rZURhc2hvZmZzZXQ6ICc0MCdcbn0pXG5cbmZ1bmN0aW9uIExvYWRpbmcocHJvcHMpIHtcbiAgcmV0dXJuIChcbiAgICA8Q29udGFpbmVyIHsuLi5wcm9wc30+XG4gICAgICA8U1ZHIHZpZXdCb3g9XCItNzUgLTc1IDE1MCAxNTBcIj5cbiAgICAgICAgPHRpdGxlPkxvYWRpbmc8L3RpdGxlPlxuICAgICAgICA8Q2lyY2xlIGN4PVwiMFwiIGN5PVwiMFwiIHI9XCIzNy41XCIgLz5cbiAgICAgIDwvU1ZHPlxuICAgIDwvQ29udGFpbmVyPlxuICApXG59XG5cbkxvYWRpbmcucHJvcFR5cGVzID0ge1xuICBzbWFsbDogUHJvcFR5cGVzLmJvb2xcbn07XG5cbmV4cG9ydCBkZWZhdWx0IExvYWRpbmciXX0= */"
});
var Circle = ( /*#__PURE__*/0, _styledBase["default"])('circle', {
  target: "e1y863ul2",
  label: "Circle"
})({
  stroke: _styles.COLORS.teal['400'],
  strokeDasharray: '240',
  strokeWidth: '8',
  strokeDashoffset: '40'
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwQ2UiLCJmaWxlIjoiLi4vc3JjL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7XG4gIENPTE9SU1xufSBmcm9tICdAdW1pY2gtbGliL3N0eWxlcydcblxuY29uc3Qgcm90YXRpb24gPSBrZXlmcmFtZXNgXG4gIGZyb20ge1xuICAgIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpO1xuICB9XG4gIHRvIHtcbiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgzNTlkZWcpO1xuICB9XG5gXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZCgnZGl2JykoXG4gIHtcbiAgICB3aWR0aDogJzEwcmVtJyxcbiAgICBoZWlnaHQ6ICcxMHJlbScsXG4gIH0sXG4gIHByb3BzID0+IHtcbiAgICBpZiAocHJvcHMuc21hbGwpIHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiAnMnJlbScsXG4gICAgICAgIGhlaWdodDogJzJyZW0nLFxuICAgICAgICAnY2lyY2xlJzoge1xuICAgICAgICAgIHN0cm9rZVdpZHRoOiAnMTInXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH0sXG4gIHtcbiAgICBhbmltYXRpb246IGAke3JvdGF0aW9ufSAuOHMgaW5maW5pdGUgbGluZWFyYFxuICB9XG4pXG5cbmNvbnN0IFNWRyA9IHN0eWxlZCgnc3ZnJykoe1xuICBmaWxsOiAndHJhbnNwYXJlbnQnXG59KVxuXG5jb25zdCBDaXJjbGUgPSBzdHlsZWQoJ2NpcmNsZScpKHtcbiAgc3Ryb2tlOiBDT0xPUlMudGVhbFsnNDAwJ10sXG4gIHN0cm9rZURhc2hhcnJheTogJzI0MCcsXG4gIHN0cm9rZVdpZHRoOiAnOCcsXG4gIHN0cm9rZURhc2hvZmZzZXQ6ICc0MCdcbn0pXG5cbmZ1bmN0aW9uIExvYWRpbmcocHJvcHMpIHtcbiAgcmV0dXJuIChcbiAgICA8Q29udGFpbmVyIHsuLi5wcm9wc30+XG4gICAgICA8U1ZHIHZpZXdCb3g9XCItNzUgLTc1IDE1MCAxNTBcIj5cbiAgICAgICAgPHRpdGxlPkxvYWRpbmc8L3RpdGxlPlxuICAgICAgICA8Q2lyY2xlIGN4PVwiMFwiIGN5PVwiMFwiIHI9XCIzNy41XCIgLz5cbiAgICAgIDwvU1ZHPlxuICAgIDwvQ29udGFpbmVyPlxuICApXG59XG5cbkxvYWRpbmcucHJvcFR5cGVzID0ge1xuICBzbWFsbDogUHJvcFR5cGVzLmJvb2xcbn07XG5cbmV4cG9ydCBkZWZhdWx0IExvYWRpbmciXX0= */");

function Loading(props) {
  return (0, _core.jsx)(Container, props, (0, _core.jsx)(SVG, {
    viewBox: "-75 -75 150 150"
  }, (0, _core.jsx)("title", null, "Loading"), (0, _core.jsx)(Circle, {
    cx: "0",
    cy: "0",
    r: "37.5"
  })));
}

Loading.propTypes = {
  small: _propTypes["default"].bool
};
var _default = Loading;
exports["default"] = _default;